// BNK: márka-szinonima query-bővítés — ha a vásárló márkanevet/gyártót ír, hozzáfűzi a
// termékcímekben használt rövidítés-tokeneket, így a rövidített nevű (márka-specifikus)
// termékek is előjönnek és előrébb rangsorolódnak.
//
// A rendszer -> betűkód adat NEM itt él: a `dinamikus_markak` metaobjektum `betukod`
// mezőjéből jön (window.BNK_SYSTEMS, lásd brand-context-picker.liquid). Itt csak azok a
// köznyelvi/rövidült alakok maradnak, amik nem rendszer-nevek, tehát metaobjektumban
// nincs hol tárolni őket.
var BNK_BRAND_SYN_EXTRA = {
  "branemark": "BR", "bone level": "BL", "bonelevel": "BL", "wieland": "WL",
  "biomet": "3I", "screw vent": "ZM", "tapered screw vent": "ZM"
};
var BNK__syn = null, BNK__synKeys = null, BNK__codes = null;
function BNK_synKey(s) {
  // ékezet-érzéketlen (Brånemark -> branemark), zárójeles utótag nélkül
  return String(s || '').replace(/[®™]/g, ' ').normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '').toLowerCase()
    .replace(/\s*\([^)]*\)/g, ' ').replace(/[^a-z0-9]+/g, ' ').trim();
}
function BNK_synMap() {
  if (BNK__syn) return BNK__syn;
  var out = {}, byMaker = {};
  (window.BNK_SYSTEMS || []).forEach(function (s) {
    if (!s || !s.k) return;
    var kv = BNK_synKey(s.v);
    if (kv && !out[kv]) out[kv] = s.k;                       // „nobel active" -> AC
    var km = BNK_synKey(s.g + ' ' + s.m);
    if (km && !out[km]) out[km] = s.k;
    // Gyűjtő-kulcsok: a gyártó neve, ill. a rendszernév első egy/két szava
    // („nobel", „astra tech", „ankylos") -> a hozzájuk tartozó ÖSSZES kód.
    var groups = [BNK_synKey(s.g)];
    var w = kv.split(' ');
    if (w.length > 1) groups.push(w[0]);
    if (w.length > 2) groups.push(w[0] + ' ' + w[1]);
    groups.forEach(function (g) {
      if (!g) return;
      byMaker[g] = byMaker[g] || [];
      if (byMaker[g].indexOf(s.k) === -1) byMaker[g].push(s.k);
    });
  });
  Object.keys(byMaker).forEach(function (g) {                // gyártó -> az összes kódja
    if (!out[g]) out[g] = byMaker[g].join(' ');
  });
  Object.keys(BNK_BRAND_SYN_EXTRA).forEach(function (k) { out[k] = BNK_BRAND_SYN_EXTRA[k]; });
  BNK__syn = out;
  return out;
}
function BNK_synKeysSorted() {
  if (!BNK__synKeys) {
    BNK__synKeys = Object.keys(BNK_synMap()).sort(function (a, b) { return b.length - a.length; });
  }
  return BNK__synKeys;
}
function BNK_codeList() {
  if (BNK__codes) return BNK__codes;
  var seen = {}, out = [];
  (window.BNK_SYSTEMS || []).forEach(function (s) {
    if (!s || !s.k) return;
    var c = s.k.toLowerCase();
    if (!seen[c]) { seen[c] = 1; out.push(c); }
  });
  Object.keys(BNK_BRAND_SYN_EXTRA).forEach(function (k) {
    BNK_BRAND_SYN_EXTRA[k].split(' ').forEach(function (c) {
      c = c.toLowerCase();
      if (c && !seen[c]) { seen[c] = 1; out.push(c); }
    });
  });
  BNK__codes = out;
  return out;
}
function BNK_expandQuery(q) {
  try {
    var ql = (" " + q.toLowerCase() + " ").replace(/[^a-z0-9 ]/g, " ").replace(/\s+/g, " ");
    // Ha a keresés már tartalmaz rövidítés-kódot, ne bővítsünk (a tag-mező megtalálja).
    var BNK_codes_ = BNK_codeList();
    for (var j = 0; j < BNK_codes_.length; j++) {
      if (ql.indexOf(" " + BNK_codes_[j] + " ") !== -1) return q;
    }
    var seen = {}, extra = [];
    // Leghosszabb kulcs nyer: ha a konkrét vonal (pl. "nobel active") illeszkedik,
    // a találatot kifehérítjük, így a bare gyártó ("nobel") már nem triggerel rá.
    var BNK_syn_ = BNK_synMap(), BNK_keys_ = BNK_synKeysSorted();
    for (var i = 0; i < BNK_keys_.length; i++) {
      var key = BNK_keys_[i];
      var k = key.replace(/[^a-z0-9 ]/g, "");
      var idx = ql.indexOf(" " + k + " ");
      if (idx !== -1) {
        ql = ql.substring(0, idx + 1) + new Array(k.length + 1).join(" ") + ql.substring(idx + 1 + k.length);
        var codes = BNK_syn_[key].split(" ");
        for (var m = 0; m < codes.length; m++) {
          var c = codes[m];
          if (c && !seen[c.toLowerCase()]) { seen[c.toLowerCase()] = 1; extra.push(c); }
        }
      }
    }
    if (extra.length) return q + " " + extra.join(" ");
  } catch (e) {}
  return q;
}

// BNK: a globális márkaválasztóban kijelölt rendszer figyelembevétele — a kompatibilis
// terméktalálatokat előre sorolja (nem rejt el semmit), és jelzősávot tesz a lista fölé.
// A termék-li data-bnk-compat/data-bnk-brand attribútumait a predictive-search szekció adja.
function BNK_applyBrandRank(root) {
  try {
    var brand = window.BionikaBrand && window.BionikaBrand.get ? window.BionikaBrand.get() : '';
    if (!brand) return;
    var norm = function (s) {
      return (s || '').toLowerCase().replace(/[®™]/g, '').replace(/\s+/g, ' ').trim();
    };
    var b = norm(brand);
    if (!b) return;
    var ul = root.querySelector('#predictive-search-results-products-list');
    if (!ul) return;
    var items = Array.prototype.slice.call(ul.children);
    var match = [], rest = [];
    items.forEach(function (li) {
      var vals = ((li.getAttribute('data-bnk-compat') || '') + '||' + (li.getAttribute('data-bnk-brand') || ''))
        .split('||').map(norm).filter(Boolean);
      var hit = vals.indexOf(b) !== -1;
      (hit ? match : rest).push(li);
    });
    if (!match.length || !rest.length) return; // mind vagy semmi egyezik → nincs mit átrendezni
    match.concat(rest).forEach(function (li) { ul.appendChild(li); });
    match.forEach(function (li) { li.classList.add('bnk-brand-hit'); });
    var note = document.createElement('p');
    note.className = 'bnk-pred-brandnote';
    note.textContent = 'Results compatible with the selected system (' + brand + ') are shown first.';
    ul.parentNode.insertBefore(note, ul);
  } catch (e) {}
}

// BNK: a kijelölt márkából keresőszó-tokenek — BIONIKA-vonalnál a vonalnév
// (pl. "BIONIKA CALLUS" → "callus"), ismert kompatibilis rendszernél a
// cím-rövidítés kód(ok) a szinonima-táblából (pl. "Ankylos® C" → "CA"),
// egyébként a márkanév szavai (pl. "ADIN® CloseFit®" → "adin closefit").
function BNK_brandQueryTokens() {
  try {
    var brand = window.BionikaBrand && window.BionikaBrand.get ? window.BionikaBrand.get() : '';
    if (!brand) return '';
    var b = brand.toLowerCase().replace(/[®™]/g, ' ').replace(/[^a-z0-9 ]/g, ' ').replace(/\s+/g, ' ').trim();
    if (!b) return '';
    var BNK_syn2_ = BNK_synMap();
    if (BNK_syn2_[b]) return BNK_syn2_[b];
    if (b.indexOf('bionika ') === 0) return b.substring(8);
    return b;
  } catch (e) { return ''; }
}

// BNK: az eredmény-oszlopok wrapperének biztosítása — ha a sima lekérés 0
// találatot adott, a szekció ki sem rendereli, pedig a márka-lekérésből van mit
// mutatni ("minta pitteasy").
function BNK_ensureWrapper(root) {
  var w = root.querySelector('#predictive-search-results-groups-wrapper');
  if (w) return w;
  var host = root.querySelector('#predictive-search-results');
  if (!host) return null;
  w = document.createElement('div');
  w.id = 'predictive-search-results-groups-wrapper';
  w.className = 'predictive-search__results-groups-wrapper';
  host.insertBefore(w, host.firstChild);
  return w;
}

// BNK: a Termékek-lista biztosítása (0 sima találatnál a csoport sem létezik).
function BNK_ensureProductsList(root) {
  var target = root.querySelector('#predictive-search-results-products-list');
  if (target) return target;
  var w = BNK_ensureWrapper(root);
  if (!w) return null;
  // a 0-termékes sima válasz --no-products módosítója egyoszloposra szűkítené
  // az utólag befésült termékeket is
  w.classList.remove('predictive-search__results-groups-wrapper--no-products');
  // ha (még) nincs Javaslatok-oszlop, a --no-suggestions módosító kell, hogy a
  // termék-csoport a teljes szélességet kapja (a BNK_injectBrandSuggestions
  // leveszi, ha később javaslatot is beemel)
  if (!root.querySelector('#predictive-search-results-queries-list')) {
    w.classList.add('predictive-search__results-groups-wrapper--no-suggestions');
  }
  var g = document.createElement('div');
  g.className = 'predictive-search__result-group';
  g.innerHTML =
    '<div><h2 id="predictive-search-products" class="predictive-search__heading text-body caption-with-letter-spacing">Products</h2>' +
    '<ul id="predictive-search-results-products-list" class="predictive-search__results-list list-unstyled" role="group" aria-labelledby="predictive-search-products"></ul></div>';
  w.appendChild(g);
  return g.querySelector('ul');
}

// BNK: rotációs lekérések terméktalálatainak hozzáfűzése a lista VÉGÉRE
// (dedupe href szerint, 10-es plafon, jelölés nélkül) — így több szavas
// keresésnél a szavak bármilyen sorrendben megtalálják a terméket.
function BNK_appendResults(root, html) {
  try {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var srcUl = doc.querySelector('#predictive-search-results-products-list');
    if (!srcUl || !srcUl.children.length) return;
    var target = BNK_ensureProductsList(root);
    if (!target) return;
    var keyOf = function (li) {
      var a = li.querySelector('a[href]');
      return a ? a.getAttribute('href').split('?')[0] : null;
    };
    var have = {};
    Array.prototype.forEach.call(target.children, function (li) {
      var k = keyOf(li);
      if (k) have[k] = 1;
    });
    Array.prototype.slice.call(srcUl.children).forEach(function (li) {
      if (target.children.length >= 10) return;
      var k = keyOf(li);
      if (!k || have[k]) return;
      have[k] = 1;
      target.appendChild(li);
    });
  } catch (e) {}
}

// BNK: a márka-lekérés terméktalálatainak előre-fésülése a sima találati listába.
// A duplikátumok (href alapján) csak jelölést kapnak; az új márka-találatok elé
// kerülnek; a lista legfeljebb 10 elemre vágva; jelzősáv, ha még nincs.
function BNK_mergeBrandResults(root, brandHtml, brandLabel) {
  try {
    var doc = new DOMParser().parseFromString(brandHtml, 'text/html');
    var brandUl = doc.querySelector('#predictive-search-results-products-list');
    if (!brandUl || !brandUl.children.length) return;
    var target = BNK_ensureProductsList(root);
    if (!target) return;
    var keyOf = function (li) {
      var a = li.querySelector('a[href]');
      return a ? a.getAttribute('href').split('?')[0] : null;
    };
    var existing = {};
    Array.prototype.forEach.call(target.children, function (li) {
      var k = keyOf(li);
      if (k) existing[k] = li;
    });
    var front = [];
    var newCount = 0;
    Array.prototype.slice.call(brandUl.children).forEach(function (li) {
      var k = keyOf(li);
      if (!k) return;
      if (existing[k]) {
        existing[k].classList.add('bnk-brand-hit');
        if (front.indexOf(existing[k]) === -1) front.push(existing[k]);
      } else if (newCount < 6) {
        // legfeljebb 6 ÚJ márka-találat, hogy az általános találatok se
        // szoruljanak ki teljesen a 10-es listából
        li.classList.add('bnk-brand-hit');
        front.push(li);
        newCount++;
      }
    });
    if (!front.length) return;
    var rest = Array.prototype.slice.call(target.children).filter(function (li) {
      return front.indexOf(li) === -1;
    });
    front.concat(rest).forEach(function (li) { target.appendChild(li); });
    while (target.children.length > 10) target.removeChild(target.lastElementChild);
    if (!brandLabel) return; // begépelt márkánál nincs külön jelzősáv
    if (!root.querySelector('.bnk-pred-brandnote')) {
      var note = document.createElement('p');
      note.className = 'bnk-pred-brandnote';
      note.textContent = 'Results compatible with the selected system (' + brandLabel + ') are shown first.';
      target.parentNode.insertBefore(note, target);
    }
  } catch (e) {}
}

// BNK: márka-/rendszernév felismerése a BEGÉPELT keresésben. Ha a keresés a
// márkanéven KÍVÜL más szavakat is tartalmaz (pl. "pitteasy univer"), a
// rendszer-kollekció javaslat kiesne (a kollekció-címre nem illeszkedik minden
// szó) — ilyenkor külön lekérés hozza be a javaslatot (BNK_injectBrandSuggestions).
function BNK_normBrand(s) {
  return (s || '').toLowerCase().replace(/[®™]/g, ' ').replace(/[^a-z0-9 ]/g, ' ').replace(/\s+/g, ' ').trim();
}

function BNK_findBrandInQuery(term) {
  try {
    var t = ' ' + BNK_normBrand(term) + ' ';
    var whole = BNK_normBrand(term);
    var cands = {};
    var add = function (s) {
      if (!s) return;
      cands[s] = 1;
      // egybeírt alak is ("pitt easy" → "pitteasy"), mert a vásárló gyakran
      // szóköz/kötőjel nélkül gépeli a márkanevet
      var compact = s.replace(/ /g, '');
      if (compact !== s) cands[compact] = 1;
    };
    if (window.MP_COMPAT) {
      Object.keys(window.MP_COMPAT).forEach(function (k) {
        var parts = k.split('|||');
        var gy = BNK_normBrand(parts[0] || '');
        var rs = BNK_normBrand(parts[1] || '');
        if (gy && rs && gy !== rs) add(gy + ' ' + rs);
        add(rs);
        add(gy);
      });
    }
    Object.keys(BNK_synMap()).forEach(function (k) { add(k); });
    var sorted = Object.keys(cands).sort(function (a, b) { return b.length - a.length; });
    for (var i = 0; i < sorted.length; i++) {
      if (whole !== sorted[i] && t.indexOf(' ' + sorted[i] + ' ') !== -1) return sorted[i];
    }
  } catch (e) {}
  return '';
}

// BNK: a csak-márkanévvel lekért válaszból a rendszer-kollekció javaslatok
// beemelése a megjelenített találatokba (dedupe href szerint; ha nincs
// Javaslatok-oszlop, létrehozzuk).
function BNK_injectBrandSuggestions(root, html) {
  try {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var colls = doc.querySelectorAll('li[id^="predictive-search-option-collection-"]');
    if (!colls.length) return;
    var wrapper = BNK_ensureWrapper(root);
    if (!wrapper) return;
    var list = root.querySelector('#predictive-search-results-queries-list');
    if (!list) {
      var group = document.createElement('div');
      group.className = 'predictive-search__result-group';
      group.innerHTML =
        '<div><h2 id="predictive-search-queries" class="predictive-search__heading text-body caption-with-letter-spacing">Suggestions</h2>' +
        '<ul id="predictive-search-results-queries-list" class="predictive-search__results-list list-unstyled" role="group" aria-labelledby="predictive-search-queries"></ul></div>';
      wrapper.insertBefore(group, wrapper.firstChild);
      wrapper.classList.remove('predictive-search__results-groups-wrapper--no-suggestions');
      list = group.querySelector('ul');
    }
    var have = {};
    Array.prototype.forEach.call(list.querySelectorAll('a[href]'), function (a) {
      have[a.getAttribute('href').split('?')[0]] = 1;
    });
    Array.prototype.forEach.call(colls, function (li) {
      var a = li.querySelector('a[href]');
      if (!a) return;
      var k = a.getAttribute('href').split('?')[0];
      if (have[k]) return;
      have[k] = 1;
      list.appendChild(li);
    });
  } catch (e) {}
}

// BNK: keresőkifejezés wildcardosítása. Minden szó `*`-ot kap, és az egybeírt
// márkanevek a kanonikus szavaikra bomlanak („pitteasy” → „pitt* easy*”) — a
// Shopify a tageket szavanként indexeli, így az egybeírt alak nem találna.
function BNK_wildcardQuery(q) {
  var out = [];
  var ws = q.split(/\s+/).filter(Boolean);
  // Mondatszerű (5+ szavas) kérdésnél NEM wildcardozunk: ott minden szóra
  // szűkíteni 0 találatot ad („mivel rögzítsem a kivehető protézist” → 12
  // találat csillag nélkül, csillagokkal 0). Az ilyet a szemantikus kereső viszi.
  if (ws.length > 4) return q;
  ws.forEach(function (w) {
    var parts = null;
    try { parts = window.BnkBrandWords ? window.BnkBrandWords(w) : null; } catch (e) {}
    if (parts && parts.length) {
      // BIONIKA (2026-10-06 natív): NINCS több `*` — a csillag részszavakra is illesztett
      // („scanbody” 322 → 1000 találat), ami sok irreleváns terméket hozott. Csak az
      // egybeírt márkanevek bontása marad („pitteasy” → „pitt easy”).
      parts.forEach(function (p) { out.push(p); });
    } else {
      out.push(w);
    }
  });
  return out.join(' ');
}

// BNK: a KERESŐ-ŰRLAP beküldésekor minden szóra `*` wildcard kerül — a teljes
// kereső (a prediktívvel ellentétben) szavanként támogatja, így a szavak
// bármilyen sorrendben, egészben vagy RÉSZLEGESEN is találnak ("minta ferde" →
// "minta* ferde*" = 142 találat). Kivétel: már van benne * vagy idézőjel,
// illetve szám-túlsúlyos (SKU/UDI) keresés — azokat a kód-normalizáló kezeli.
document.addEventListener(
  'submit',
  function (e) {
    try {
      var form = e.target;
      if (!form || !form.action || form.action.indexOf('/search') === -1) return;
      var input = form.querySelector('input[name="q"]');
      if (!input || !input.value) return;
      var q = input.value.trim();
      if (!q || q.indexOf('*') !== -1 || q.indexOf('"') !== -1) return;
      if (q.replace(/[^0-9]/g, '').length >= 6) return;
      // Elgépelés javítása MÁR BEKÜLDÉSKOR: a „lokatr fej” egyébként a „fej”-re
      // adna 132 lényegtelen találatot (nem lenne 0, tehát a mentőháló sem lépne).
      var fixed = null;
      try { fixed = window.BnkSpellFix ? window.BnkSpellFix(q) : null; } catch (err2) {}
      input.value = BNK_wildcardQuery(fixed || q);
      if (fixed) {
        // A találati oldal jelzősávjához (semantic-search.js): mi volt az eredeti.
        var h = form.querySelector('input[name="bnk_fix"]');
        if (!h) {
          h = document.createElement('input');
          h.type = 'hidden';
          h.name = 'bnk_fix';
          form.appendChild(h);
        }
        h.value = q;
      }
    } catch (err) {}
  },
  true
);

class PredictiveSearch extends SearchForm {
  constructor() {
    super();
    this.cachedResults = {};
    this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
    this.allPredictiveSearchInstances = document.querySelectorAll('predictive-search');
    this.isOpen = false;
    this.abortController = new AbortController();
    this.searchTerm = '';

    this.setupEventListeners();
  }

  setupEventListeners() {
    this.input.form.addEventListener('submit', this.onFormSubmit.bind(this));

    this.input.addEventListener('focus', this.onFocus.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.addEventListener('keyup', this.onKeyup.bind(this));
    this.addEventListener('keydown', this.onKeydown.bind(this));
  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    super.onChange();
    const newSearchTerm = this.getQuery();
    if (!this.searchTerm || !newSearchTerm.startsWith(this.searchTerm)) {
      // Remove the results when they are no longer relevant for the new search term
      // so they don't show up when the dropdown opens again
      this.querySelector('#predictive-search-results-groups-wrapper')?.remove();
    }

    // Update the term asap, don't wait for the predictive search query to finish loading
    this.updateSearchForTerm(this.searchTerm, newSearchTerm);

    this.searchTerm = newSearchTerm;

    if (!this.searchTerm.length) {
      this.close(true);
      return;
    }

    this.getSearchResults(this.searchTerm);
  }

  onFormSubmit(event) {
    if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a')) event.preventDefault();
  }

  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.searchTerm = '';
      this.abortController.abort();
      this.abortController = new AbortController();
      this.closeResults(true);
    }
  }

  onFocus() {
    const currentSearchTerm = this.getQuery();

    if (!currentSearchTerm.length) return;

    if (this.searchTerm !== currentSearchTerm) {
      // Search term was changed from other search input, treat it as a user change
      this.onChange();
    } else if (this.getAttribute('results') === 'true') {
      this.open();
    } else {
      this.getSearchResults(this.searchTerm);
    }
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onKeyup(event) {
    if (!this.getQuery().length) this.close(true);
    event.preventDefault();

    switch (event.code) {
      case 'ArrowUp':
        this.switchOption('up');
        break;
      case 'ArrowDown':
        this.switchOption('down');
        break;
      case 'Enter':
        this.selectOption();
        break;
    }
  }

  onKeydown(event) {
    // Prevent the cursor from moving in the input when using the up and down arrow keys
    if (event.code === 'ArrowUp' || event.code === 'ArrowDown') {
      event.preventDefault();
    }
  }

  updateSearchForTerm(previousTerm, newTerm) {
    const searchForTextElement = this.querySelector('[data-predictive-search-search-for-text]');
    const currentButtonText = searchForTextElement?.innerText;
    if (currentButtonText) {
      if (currentButtonText.match(new RegExp(previousTerm, 'g')).length > 1) {
        // The new term matches part of the button text and not just the search term, do not replace to avoid mistakes
        return;
      }
      const newButtonText = currentButtonText.replace(previousTerm, newTerm);
      searchForTextElement.innerText = newButtonText;
    }
  }

  switchOption(direction) {
    if (!this.getAttribute('open')) return;

    const moveUp = direction === 'up';
    const selectedElement = this.querySelector('[aria-selected="true"]');

    // Filter out hidden elements (duplicated page and article resources) thanks
    // to this https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/offsetParent
    const allVisibleElements = Array.from(this.querySelectorAll('li, button.predictive-search__item')).filter(
      (element) => element.offsetParent !== null
    );
    let activeElementIndex = 0;

    if (moveUp && !selectedElement) return;

    let selectedElementIndex = -1;
    let i = 0;

    while (selectedElementIndex === -1 && i <= allVisibleElements.length) {
      if (allVisibleElements[i] === selectedElement) {
        selectedElementIndex = i;
      }
      i++;
    }

    this.statusElement.textContent = '';

    if (!moveUp && selectedElement) {
      activeElementIndex = selectedElementIndex === allVisibleElements.length - 1 ? 0 : selectedElementIndex + 1;
    } else if (moveUp) {
      activeElementIndex = selectedElementIndex === 0 ? allVisibleElements.length - 1 : selectedElementIndex - 1;
    }

    if (activeElementIndex === selectedElementIndex) return;

    const activeElement = allVisibleElements[activeElementIndex];

    activeElement.setAttribute('aria-selected', true);
    if (selectedElement) selectedElement.setAttribute('aria-selected', false);

    this.input.setAttribute('aria-activedescendant', activeElement.id);
  }

  selectOption() {
    const selectedOption = this.querySelector('[aria-selected="true"] a, button[aria-selected="true"]');

    if (selectedOption) selectedOption.click();
  }

  getSearchResults(searchTerm) {
    // BNK: a cache-kulcsban a kijelölt márka is szerepel, mert a végleges
    // (összefésült) találati lista márkafüggő.
    const activeBrand = window.BionikaBrand && window.BionikaBrand.get ? window.BionikaBrand.get() || '' : '';
    const queryKey = (searchTerm + '::' + activeBrand).replace(/\s+/g, '-').toLowerCase();
    this.setLiveRegionLoadingState();

    if (this.cachedResults[queryKey]) {
      this.renderSearchResults(this.cachedResults[queryKey]);
      const searchDeferred = this.dispatchSearchUpdateEvent(searchTerm);
      searchDeferred?.resolve({ totalCount: this.getTotalResultCount() });
      return;
    }

    const searchDeferred = this.dispatchSearchUpdateEvent(searchTerm);

    // BIONIKA: a keresőkifejezést kibővítjük (SKU-normalizálás, szinonimák), és a
    // szerveroldali találatokat több mezőre engedjük illeszkedni.
    const buildUrl = (q) =>
      `${routes.predictive_search_url}?q=${encodeURIComponent(
        BNK_expandQuery(q)
      )}&section_id=predictive-search&resources[options][fields]=title,product_type,variants.title,vendor,tag`;

    // BNK: második, márkával bővített lekérés — a kijelölt rendszer találatai
    // gyakran be sem férnek a sima top-10-be (ezért nem elég az átrendezés).
    // Ha a felhasználó már beírta a márka valamelyik tokenjét, nem kell.
    const brandTokens = BNK_brandQueryTokens();
    const termPadded = ' ' + searchTerm.toLowerCase().replace(/\s+/g, ' ') + ' ';
    const needBrandFetch =
      brandTokens &&
      brandTokens.split(' ').every(function (t) {
        return t && termPadded.indexOf(' ' + t.toLowerCase() + ' ') === -1;
      });

    const fetchText = (url) =>
      fetch(url, { signal: this.abortController.signal }).then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }
        return response.text();
      });

    // BNK: ha a keresésben márkanév + további szavak vannak ("pitteasy univer"),
    // a rendszer-kollekció javaslatot csak-márkás lekéréssel hozzuk be (expand
    // NÉLKÜL — a szinonima-kódok a kollekció-címekre nem illeszkednének).
    const typedBrand = BNK_findBrandInQuery(searchTerm);
    const suggestUrl = typedBrand
      ? `${routes.predictive_search_url}?q=${encodeURIComponent(typedBrand)}&section_id=predictive-search&resources[options][fields]=title,product_type,variants.title,vendor,tag`
      : null;

    // BNK: több szavas keresésnél ROTÁCIÓS lekérések — a Shopify csak az UTOLSÓ
    // szót kezeli előtagként, ezért minden szót egyszer az utolsó helyre
    // forgatunk ("minta pitteasy" → "pitteasy minta" is fut). Így a szavak
    // bármilyen sorrendben (az épp gépelt szó töredékesen is) találnak.
    const words = searchTerm.split(/\s+/).filter(Boolean);
    const rotationUrls = [];
    if (words.length >= 2 && words.length <= 4) {
      for (var wi = 0; wi < words.length - 1; wi++) {
        var rot = words.slice(0, wi).concat(words.slice(wi + 1)).join(' ') + ' ' + words[wi];
        rotationUrls.push(buildUrl(rot));
      }
    }

    // BNK: elgépelés-javítás (search-dictionary.js → BnkSpellFix). A javított
    // kifejezéssel is lekérünk, és az eredményt a lista végére fésüljük — így az
    // elírás nem üres legördülőt, hanem valódi találatokat ad.
    let spellUrl = null;
    try {
      var fixed = window.BnkSpellFix ? window.BnkSpellFix(searchTerm) : null;
      if (fixed) {
        rotationUrls.push(buildUrl(fixed));
        spellUrl = fixed;
      }
    } catch (e) {}

    Promise.all([
      fetchText(buildUrl(searchTerm)),
      needBrandFetch
        ? // A márka-tokenek ELÖL állnak: a prediktív keresés csak az UTOLSÓ szót
          // kezeli előtagként, annak a felhasználó gépelt szavának kell lennie
          // ("minta" → "Mintavételi").
          fetchText(buildUrl(brandTokens + ' ' + searchTerm)).catch(function () { return null; })
        : Promise.resolve(null),
      suggestUrl ? fetchText(suggestUrl).catch(function () { return null; }) : Promise.resolve(null),
    ].concat(
      rotationUrls.map((u) => fetchText(u).catch(function () { return null; }))
    ))
      .then(([text, brandText, suggestText, ...rotationTexts]) => {
        const resultsMarkup = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('#shopify-section-predictive-search').innerHTML;
        this.renderSearchResults(resultsMarkup);
        if (brandText) {
          const brandMarkup = new DOMParser()
            .parseFromString(brandText, 'text/html')
            .querySelector('#shopify-section-predictive-search')?.innerHTML;
          if (brandMarkup) BNK_mergeBrandResults(this.predictiveSearchResults, brandMarkup, activeBrand);
        }
        rotationTexts.forEach((rotText) => {
          if (!rotText) return;
          const rotMarkup = new DOMParser()
            .parseFromString(rotText, 'text/html')
            .querySelector('#shopify-section-predictive-search')?.innerHTML;
          if (rotMarkup) BNK_appendResults(this.predictiveSearchResults, rotMarkup);
        });
        if (suggestText) {
          const suggestMarkup = new DOMParser()
            .parseFromString(suggestText, 'text/html')
            .querySelector('#shopify-section-predictive-search')?.innerHTML;
          if (suggestMarkup) BNK_injectBrandSuggestions(this.predictiveSearchResults, suggestMarkup);
        }
        // Save bandwidth keeping the cache in all instances synced — a VÉGLEGES
        // (márka-összefésült) markupot tesszük el.
        const finalMarkup = this.predictiveSearchResults.innerHTML;
        this.allPredictiveSearchInstances.forEach((predictiveSearchInstance) => {
          predictiveSearchInstance.cachedResults[queryKey] = finalMarkup;
        });

        searchDeferred?.resolve({ totalCount: this.getTotalResultCount() });
      })
      .catch((error) => {
        if (error?.code === 20) {
          // Code 20 means the call was aborted
          searchDeferred?.reject(error);
          return;
        }
        searchDeferred?.reject(error);
        this.close();
        throw error;
      });
  }

  getTotalResultCount() {
    return parseInt(this.predictiveSearchResults.querySelector('[data-total-results]')?.dataset.totalResults) || 0;
  }

  dispatchSearchUpdateEvent(query) {
    const { SearchUpdateEvent } = window.StandardEvents || {};
    if (!SearchUpdateEvent) return null;

    const deferred = SearchUpdateEvent.createPromise();
    this.dispatchEvent(
      new SearchUpdateEvent({
        search: { query },
        promise: deferred.promise,
      })
    );
    return deferred;
  }

  setLiveRegionLoadingState() {
    this.statusElement = this.statusElement || this.querySelector('.predictive-search-status');
    this.loadingText = this.loadingText || this.getAttribute('data-loading-text');

    this.setLiveRegionText(this.loadingText);
    this.setAttribute('loading', true);
  }

  setLiveRegionText(statusText) {
    this.statusElement.setAttribute('aria-hidden', 'false');
    this.statusElement.textContent = statusText;

    setTimeout(() => {
      this.statusElement.setAttribute('aria-hidden', 'true');
    }, 1000);
  }

  renderSearchResults(resultsMarkup) {
    this.predictiveSearchResults.innerHTML = resultsMarkup;
    BNK_applyBrandRank(this.predictiveSearchResults);
    this.setAttribute('results', true);

    this.setLiveRegionResults();
    this.open();
  }

  setLiveRegionResults() {
    this.removeAttribute('loading');
    this.setLiveRegionText(this.querySelector('[data-predictive-search-live-region-count-value]').textContent);
  }

  getResultsMaxHeight() {
    this.resultsMaxHeight =
      window.innerHeight - document.querySelector('.section-header')?.getBoundingClientRect().bottom;
    return this.resultsMaxHeight;
  }

  open() {
    this.predictiveSearchResults.style.maxHeight = this.resultsMaxHeight || `${this.getResultsMaxHeight()}px`;
    this.setAttribute('open', true);
    this.input.setAttribute('aria-expanded', true);
    this.isOpen = true;
  }

  close(clearSearchTerm = false) {
    this.closeResults(clearSearchTerm);
    this.isOpen = false;
  }

  closeResults(clearSearchTerm = false) {
    if (clearSearchTerm) {
      this.input.value = '';
      this.removeAttribute('results');
    }
    const selected = this.querySelector('[aria-selected="true"]');

    if (selected) selected.setAttribute('aria-selected', false);

    this.input.setAttribute('aria-activedescendant', '');
    this.removeAttribute('loading');
    this.removeAttribute('open');
    this.input.setAttribute('aria-expanded', false);
    this.resultsMaxHeight = false;
    this.predictiveSearchResults.removeAttribute('style');
  }
}

customElements.define('predictive-search', PredictiveSearch);
